import { useCallback, useState } from "react";
import { getPartnerInvestmentsByDateRange } from "../firebase/partnerInvestment/getPartnerInvestmentsByDateRange";
import { PartnerInvestmentRecord } from "../models/partnerInvestment";
import {
	calculatePartnerInvestmentSummary,
	PartnerInvestmentSummary
} from "../utils/partnerInvestmentCalculations";

const emptySummary: PartnerInvestmentSummary = {
	totalInvested: 0,
	totalOutstanding: 0,
	activeCount: 0,
	partnerBreakdown: {}
};

export const usePartnerInvestments = () => {
	const [investments, setInvestments] = useState<PartnerInvestmentRecord[]>(
		[]
	);
	const [summary, setSummary] =
		useState<PartnerInvestmentSummary>(emptySummary);
	const [loading, setLoading] = useState(true);

	const fetchPartnerInvestments = useCallback(
		async (startDate: string, endDate: string, items?: Array<any>) => {
			setLoading(true);
			try {
				const data = await getPartnerInvestmentsByDateRange(
					startDate,
					endDate
				);
				const sorted = [...data].sort(
					(a, b) =>
						new Date(b.investmentDate).getTime() -
						new Date(a.investmentDate).getTime()
				);
				setInvestments(sorted);
				setSummary(calculatePartnerInvestmentSummary(sorted, items));
			} catch (error) {
				console.error("Failed to load partner investments:", error);
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	return { investments, summary, loading, fetchPartnerInvestments };
};
